import { Component, OnDestroy, OnInit } from '@angular/core';

import { Observable, of } from 'rxjs';
import { UsersStore } from '@fry/lib/users';
import { ListDefaults, ListService } from '@fry/lib/list';
import { UsersSearch } from '@fry/components/users/users.search';
import { OrganisationService } from '@fry/lib/organisations';
import { EASLinkAction } from '@fry/components/common/buttons/buttons.service';


@Component({
    selector: 'app-user-list',
    templateUrl: './user-list.component.html',
    styleUrls: ['./user-list.component.css'],
    standalone: false
})
export class UserListComponent implements OnInit, OnDestroy {

  public items = this.list.items;
  public canCreateUsers: Observable<boolean>;
  public actions: EASLinkAction[] = [{
    type: 'link',
    label: $localize `Create user`,
    condition: () => {
      return this.organisation.canCreateUsers();
    },
    link: of(['add']),
    color: 'primary',
  }];

  constructor(
    private users: UsersStore,
    private search: UsersSearch,
    private list: ListService,
    private organisation: OrganisationService,
  ) {
    this.canCreateUsers = organisation.canCreateUsers();
  }

  ngOnInit() {
    const defaults: ListDefaults = {
      searchModel: {
        filter: {
          state: ['active'],
        },
        sort: {}
      }
    };
    this.list.setupWith(this.users, this.search, undefined, defaults).subscribe();
  }

  ngOnDestroy() {
  }

}
